//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { PLATFORMS, LAYOUT_TYPES } from '@/utils/constant';
import layoutDrawer from './create.vue';
import { whereGql, calVariables, request } from '@/graphql/util';
// eslint-disable-next-line no-unused-vars
import { GetKvlist, UpdateKv, AddKv } from '@/api/kv.js';
import layoutDistribute from '../metadata/layout/layout-distribute.vue';
import { mapGetters, mapMutations } from 'vuex';
import messageBox from '@/components/messageBox';
import { uniqWith, cloneDeep } from 'lodash';
import releaseConfirm from '../metadata/layout/release-confirm.vue';
import dayjs from 'dayjs';
import { componentTypes, businessTypes } from './constants';

export default {
  name: 'LayoutManage',
  components: {
    layoutDrawer,
    layoutDistribute,
    messageBox,
    releaseConfirm,
  },
  data() {
    return {
      activeName: '2',
      distributeIsShow: false,
      searchForm: {
        page: 1,
        page_size: 99999999,
        type: '',
        name: '',
        platform: null,
        layout_type: '',
        is_present: null,
        business_type: '',
      },
      page: 1,
      pageSize: 10,
      // 相关应用
      appOptions: [],
      objectName: '',
      objectId: '',
      // 布局类型
      LAYOUT_TYPES,
      PLATFORMS,
      metadataList: [],
      total: 0,
      drawerVisible: false,
      isCopy: false,
      platformCode: 'miniprogram_H5',
      typeCode: 'list',
      copyForm: {
        appid: null,
        platform: 4,
        name: '',
        type: 'list',
        layout_json: '',
        usage: '',
        stable_layout_json: '',
        code: '',
        remark: '',
        object_code: '',
        pattern_flag: false,
        pattern_rule: '',
        pattern_rule_text: '',
      },
      platformCodeMap: {
        1: 'miniprogram',
        2: 'PC/Web',
        3: 'H5',
        4: 'miniprogram_H5',
      },
      list: [],
      purposeSceneList: [],
      // 保存用户自定义的customer值，方便新增。
      customerKVInfo: {},
      // 是否勾选全部
      checkAll: false,
      isIndeterminate: false,
      checkedList: [],
      changeFlag: false,
      releaseConfirmIsShow: false,
      componentTypes,
      businessTypes,
    };
  },
  computed: {
    ...mapGetters('user', ['getElementList']),
    ...mapGetters({
      getLayoutParams: 'layout/getLayoutParams',
    }),
    appOptionsMap() {
      const obj = {};
      this.appOptions.forEach((item) => {
        obj[item.id] = item.name;
      });
      return obj;
    },
    metadataMap() {
      const obj = {};
      this.metadataList.forEach((item) => {
        obj[item.name] = item.display_name;
      });
      return obj;
    },
    layoutTypeMap() {
      const obj = {};
      this.LAYOUT_TYPES.forEach((item) => {
        obj[item.value] = item.label;
      });
      return obj;
    },
    distributeDimension() {
      return this.activeName === '1' ? 'record_type' : 'usage';
    },
    jurisdiction() {
      return {
        layoutManage: this.getElementList.includes('layout-manage'),
        layoutDistribute: this.getElementList.includes('layout-distribute'),
        layoutReleaseJson: this.getElementList.includes('layout-release-json'),
        componentManagement_createItem: this.getElementList.includes(
          'componentManagement_createItem',
        ),
      };
    },
    type() {
      return this.activeName === '1' ? 'layout-manage-object' : 'layout-manage-customer';
    },
    PLATFORMS_MAP() {
      const map = {};
      this.PLATFORMS.forEach((item) => {
        map[item.value] = item.label;
      });
      return map;
    },
    showList() {
      return (this.list || []).slice((this.page - 1) * this.pageSize, this.page * this.pageSize);
    },
    checkableList() {
      return (this.list || []).filter((item) => item.is_equal_json !== true);
    },
  },
  watch: {
    showList() {
      this.setSelection();
    },
  },
  async mounted() {
    this.getComponentList();
  },
  methods: {
    ...mapMutations({
      setLayoutParams: 'layout/setLayoutParams',
    }),
    getBusinessType(val) {
      return businessTypes.find((item) => item.value === val)?.label;
    },
    geComponentType(val) {
      return componentTypes.find((item) => item.value === val)?.label;
    },
    getPlatform(val) {
      return (val || '')
        .split(',')
        .map((i) => PLATFORMS.find((item) => item.value === Number(i))?.label)
        ?.join('、');
    },
    getLayout_type(val) {
      return (val || '')
        .split(',')
        .map((i) => LAYOUT_TYPES.find((item) => item.value === i)?.label)
        ?.join('、');
    },
    formatDate(val) {
      if (!val) return '-';
      return dayjs(val * 1000).format('YYYY-MM-DD HH:mm:ss');
    },

    async getComponentList() {
      const filterArr = [
        {
          whereGqlType: 'like',
          type: `%${this.activeName}%`,
        },
      ];
      if (this.searchForm.name) {
        filterArr.push({
          whereGqlType: 'like',
          name: `%${this.searchForm.name}%`,
        });
      }
      if (this.searchForm.business_type) {
        filterArr.push({
          whereGqlType: 'eq',
          business_type: `${this.searchForm.business_type}`,
        });
      }
      if (this.searchForm.layout_type?.length) {
        filterArr.push({
          whereGqlType: 'include_any',
          layout_type: this.searchForm.layout_type,
        });
      }
      if (this.searchForm.platform?.length) {
        filterArr.push({
          whereGqlType: 'include_any',
          platform: this.searchForm.platform,
        });
      }
      if (typeof this.searchForm.is_present === 'boolean') {
        filterArr.push({
          whereGqlType: 'eq',
          is_present: `${this.searchForm.is_present}`,
        });
      }
      const getComponentListGql = `query{$tableName (_limit:$limit,_offset:$offset,$filter,_order_by: {create_time: _desc}) {_aggregate{_count}id,name,code,type,platform,business_type,component_type,layout_type,create_time,update_time,create_by:create_by.name,is_present}} `;
      console.log(filterArr, 'filterArr');
      const data = {
        tableName: 'component_manage',
        limit: this.pageSize,
        offset: this.pageSize * (this.page - 1),
        filter: whereGql(filterArr),
      };
      try {
        const result = await request('/api/access/pb/cmd/DataServer/DataService/GraphqlQuery', {
          query: calVariables(getComponentListGql, data),
        });
        if (result) {
          this.list = result.component_manage?._data || [];
          this.total = result.component_manage?._aggregate.count || 0;
        }
      } catch (error) {
        this.list = [];
        this.total = 0;
      }
    },

    onClickDistribute() {
      this.distributeIsShow = true;
    },
    onCloseDistribute() {
      this.distributeIsShow = false;
    },
    async handleAddPurposeScene(val) {
      console.log('------handleAddPurposeScene------', val);
      console.log('------customerKVInfo------', this.customerKVInfo);
      const rawValue = this.customerKVInfo.value;
      const list = JSON.parse(rawValue);
      list.push({
        code: val,
        name: val,
      });
      await UpdateKv({
        ...this.customerKVInfo,
        tableName: 'kv',
        value: JSON.stringify(list).replace(/\\"/g, `\\\\"`).replace(/"/g, `\\"`),
      });
      this.getPurposeSceneList();
    },
    // 获取相关应用列表
    async getAppOptions() {
      await this.$request({
        url: this.$api.getAppList,
        data: { page_size: 9999 },
      }).then((res) => {
        this.appOptions = res.data;
      });
    },
    // 获取元数据列表
    async getObjectList() {
      await this.$request({
        url: this.$api.GetComponentList,
        data: {
          keyword: '',
          object_name: '',
          offset: 0,
          limit: 99999,
          sort: 'create_time desc',
        },
      })
        .then((res) => {
          this.metadataList = res.objects;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 根据布局id获取布局详细信息
    async getLayoutDetail(id) {
      await this.$request({
        url: this.$api.getLayoutInfo,
        data: {
          id,
        },
      })
        .then((res) => {
          this.objectName = res.object_code;
          Object.keys(this.copyForm).forEach((key) => {
            this.copyForm[key] = res[key];
          });
          this.copyForm.code = `${this.copyForm.code}_copy`;
          this.copyForm.name = `${this.copyForm.name}-副本`;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    handleSetComponentParams() {
      this.setLayoutParams({
        activeName: this.activeName,
        searchForm: cloneDeep(this.searchForm),
        page: this.page,
        pageSize: this.pageSize,
      });
    },
    handleSearch() {
      this.page = 1;
      this.getComponentList();
      this.handleSetComponentParams();
    },
    resetForm() {
      this.$refs.searchForm.resetFields();
      this.searchForm.platform = null;
      this.searchForm.appid = null;
      this.handleSearch();
    },
    toLayoutSearch() {
      this.$router.push({
        name: 'layout-search',
        query: { layout_type: this.activeName === '1' ? 'object' : 'other' },
      });
    },
    // 跳转详情页
    goComponentDetail(row) {
      this.$router.push({
        name: 'component-detail',
        query: {
          id: row.id,
        },
      });
    },
    handleTabChange(tab) {
      console.log(tab, '  v-model=  v-model=  v-model=');
      this.searchForm = {
        page: 1,
        page_size: 99999999,
        type: this.activeName,
        name: '',
      };
      this.list = [];
      this.page = 1;
      this.pageSize = 10;
      this.getComponentList();
    },

    addOtherLayout() {
      this.drawerVisible = true;
    },
    handleClose() {
      this.drawerVisible = false;
    },
    // 新增
    async handleSubmit(submitData) {
      console.log(submitData, 'submitData');
      const addComponentGql = `mutation insert {$tableName(_values: {${Object.entries(submitData)
        .map(([key, value]) => `${key}: ${JSON.stringify(value)},`)
        .join('\n')}}) }`;
      const data = {
        tableName: 'component_manage',
      };
      try {
        const result = await request('/api/access/pb/cmd/DataServer/DataService/GraphqlQuery', {
          query: calVariables(addComponentGql, data),
        });
        if (result) {
          this.$message.success('新增成功');
          this.drawerVisible = false;
        }
      } catch (error) {
        this.$message.success('新增失败');
      }
      this.getComponentList();
    },
    // 向条件表达式框中插入内容
    handleInsertValue(value) {
      this.copyForm.pattern_rule_text = value;
    },
    // 生成code
    // value - 对应的值
    // field - 值对应的字段名，可选项：
    // layout_type - 布局类型
    // platform - 终端
    // 其他暂不需要处理
    confirmCode(value, field) {
      const random = this.createRand(1000, 9999);
      if (field === 'layout_type') {
        this.typeCode = value;
      } else if (field === 'platform') {
        this.platformCode = this.platformCodeMap[value];
      }
      this.copyForm.code =
        this.activeName === '1'
          ? `${this.copyForm.object_code}_${this.platformCode}_${this.typeCode}_${random}`
          : `${this.platformCode}_${this.copyForm.usage}_${random}`;
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.page = 1;
      this.getComponentList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getComponentList();
    },
    // 生成随机数
    createRand(min, max) {
      return Math.floor(Math.random() * (max - min)) + min;
    },
    handleDelete({ id }) {
      this.$refs.messageBox.show({
        title: `确定要删除吗？`,
        noBody: true,
        titleIconType: 'warning',
        needCancel: true,
        cancelAction: this.$refs.messageBox.close,
        confirmAction: async () => {
          const deleteComponentListGql = `mutation delete {$tableName(_where: {id: $id})}`;
          const data = { tableName: 'component_manage', id };
          try {
            const result = await request('/api/access/pb/cmd/DataServer/DataService/GraphqlQuery', {
              query: calVariables(deleteComponentListGql, data),
            });
            if (result) {
              this.$message.success('删除成功');
            }
          } catch (error) {
            this.$message.success('删除失败');
          }
          this.$refs.messageBox.close();
          this.getComponentList();
        },
      });
    },
    selectableCheck(row) {
      return row.is_equal_json !== true;
    },
    setSelection() {
      this.changeFlag = true;
      this.$nextTick(() => {
        this.showList.forEach((item) => {
          if (this.checkedList.findIndex((subItem) => subItem.id === item.id) > -1) {
            this.$refs.list.toggleRowSelection(item, true);
          }
        });
        this.changeFlag = false;
      });
    },
    handleSelectionChange(val) {
      if (!this.changeFlag) {
        let newCheckedList = this.checkedList;
        const deletedList = (this.showList || []).filter((item) => {
          return (val || []).findIndex((subItem) => subItem.id === item.id) === -1;
        });
        newCheckedList = newCheckedList.filter((item) => {
          return (deletedList || []).findIndex((subItem) => subItem.id === item.id) === -1;
        });
        newCheckedList = newCheckedList.concat(val);
        this.checkedList = uniqWith(newCheckedList, (a, b) => a.id === b.id);
        const len = this.checkedList.length;
        this.checkAll = len === this.checkableList.length;
        this.isIndeterminate = len > 0 && len < this.checkableList.length;
      }
    },
    handleCheckAll() {
      if (this.checkAll) {
        this.checkedList = [...this.checkableList];
        const len = this.checkedList.length;
        this.isIndeterminate = len > 0 && len < this.checkableList.length;
        this.setSelection();
        this.$message.info(`共选中${len}条布局数据`);
      } else {
        this.checkedList = [];
        this.$refs.list.clearSelection();
      }
    },
    async onConfirmRelease(versionDesc) {
      if (versionDesc) {
        await this.$request({
          url: this.$api.releaseLayoutJson,
          data: {
            ids: (this.checkedList || []).map((item) => item.id),
            version_desc: versionDesc,
          },
        });
        this.releaseConfirmIsShow = false;
        this.$message.success('布局新版本已生效');
        this.getComponentList();
      } else {
        this.releaseConfirmIsShow = false;
      }
    },
    releaseLayoutJson() {
      this.releaseConfirmIsShow = true;
    },
  },
};
